import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, msg: "" };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, msg: error?.message || "Unexpected error" };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App crashed:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 text-center" data-testid="app-error-boundary">
          <h1 className="font-heading text-2xl font-bold">Something went wrong</h1>
          <p className="text-sm text-muted-foreground max-w-md break-words">{this.state.msg}</p>
          <div className="flex gap-3">
            <button
              onClick={() => window.location.reload()}
              className="rounded-sm bg-primary text-primary-foreground px-4 py-2 text-sm font-medium"
              data-testid="error-reload"
            >
              Reload
            </button>
            <button
              onClick={() => { window.location.href = "/"; }}
              className="rounded-sm border border-border px-4 py-2 text-sm font-medium"
              data-testid="error-home"
            >
              Back to dashboard
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
